const initialState = {
  tax_slab: [],
  isLoding : false
 
};

const TaxSlabApiReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOADING":
      return {
        ...state,
        isLoding: action.payload
      };

    case "GET_TAX_SLAB_SUCCESS":
      return {
        ...state,
        tax_slab: action.payload,
        error: null
      };
    case "GET_TAX_SLAB_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "ADD_TAX_SLAB_SUCCESS":
      return {
        ...state,
        error: null
      };
    case "ADD_TAX_SLAB_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_TAX_SLAB_SUCCESS":
      return {
        ...state,
        tax_slab: action.payload,
      };

    case "UPDATE_TAX_SLAB_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "DELETE_TAX_SLAB_SUCCESS":
      return {
        ...state,
        tax_slab: action.payload,

        error: null
      };

    case "DELETE_TAX_SLAB_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    default:
      return state;
  }
};

export default TaxSlabApiReducer;
